import { Checkbox, CheckboxValue, Textbox } from "capitalrx-components-2.0/lib/forms";
import { Icon } from "capitalrx-components-2.0/lib/general";
import { Shelf, Stack, useResponsive } from "capitalrx-components-2.0/lib/layout";
import { Body } from "capitalrx-components-2.0/lib/typography";

import { STANDARD_RESPONSIVE_LAYOUT } from "@/constants";

import styles from "./PACaseFilterBar.module.scss";

const STATUS_OPTIONS = ["In Progress", "Approved", "Denied"];

interface PACaseFilterBarProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  selectedStatuses: string[];
  onStatusToggle: (status: string) => void;
  actionRequired: CheckboxValue;
  onActionRequiredChange: (value: CheckboxValue) => void;
  searchInstructions?: string;
}

export const PACaseFilterBar = ({
  searchTerm,
  onSearchChange,
  selectedStatuses,
  onStatusToggle,
  actionRequired,
  onActionRequiredChange,
  searchInstructions,
}: PACaseFilterBarProps) => {
  const { Layout } = useResponsive(STANDARD_RESPONSIVE_LAYOUT);

  const selectedLabels = selectedStatuses.length ? selectedStatuses : ["all"];

  return (
    <Stack>
      <Textbox
        prefix={<Icon name="search" size="small" />}
        hideLabel
        placeholder="Search"
        instructions={searchInstructions}
        value={searchTerm}
        onChange={(value) => onSearchChange(value || "")}
      />
      <Stack spacing="mini">
        <Body className={styles.SectionText}>filter by status</Body>
        <Layout spacing="small">
          <Shelf spacing="small">
            {STATUS_OPTIONS.map((label) => (
              <button
                key={label}
                onClick={() => onStatusToggle(label)}
                className={`${selectedStatuses.includes(label) ? styles.StatusFilterActive : styles.StatusFilter}${actionRequired ? ` ${styles.StatusFilterDisabled}` : ""}`}
                disabled={!!actionRequired}
              >
                {label}
              </button>
            ))}
            <Shelf.Spacer />
          </Shelf>
          <Shelf.Spacer />
          <Checkbox
            hideLabel
            label="Only show cases with Action Required"
            onChange={onActionRequiredChange}
            value={actionRequired}
          />
        </Layout>
      </Stack>
      <Body className={styles.SectionText}>{`${selectedLabels.join(", ")} cases`.toLowerCase()}</Body>
    </Stack>
  );
};

export default PACaseFilterBar;
